import { ErrorService } from 'services/error-service';
import { autoinject, BindingEngine } from 'aurelia-framework';
import { UserService } from 'services/user-service';
import { UserModels } from '../../models/UserModels';
import { connectTo } from 'aurelia-store';
import { ApplicationState } from 'lib/state';
import { PubSub } from 'lib/event/PubSub';
import { AsyncErrorHandler } from 'lib/ui';
import { FilterManager } from 'lib/tables/FilterManager';
import { Filters } from 'elements/Filter';
import { RoleService } from 'services/role-service';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { AccountService } from 'services/account-service';

@autoinject
@connectTo()
export class UserList {
  private users: Array<UserModels.User>;
  protected state: ApplicationState;
  
  //There are to many administrators in Netlog and impersonate other users is only available for a handful of people
  protected canImpersonateUser: boolean = false;
  
  filteredUsers: Array<UserModels.User>;

  constructor(
    private router: Router,
    private userService: UserService,
    private accountService: AccountService,
    private errorService: ErrorService,
    private pubsub: PubSub,
    private t: I18N,
    protected fm: FilterManager,
    protected roleServicet: RoleService
  ) {
    pubsub.sub('filter-manager:filter-changed', () => {
      this.getUsers();
    });
  }

  @AsyncErrorHandler
  async getRoles() {
    return await this.roleServicet.getAll();
  }

  async attached() {
    if (this.state.user.Email === 'lill.jacobsen@aquaknowledge.no' || this.state.user.Email === 'tt@vonin.com' || this.state.user.Email === 'ulrik.eikas@twoday.com'){
      this.canImpersonateUser = true;
    }

    const roles = await this.getRoles();
    const translatedRoles = roles.map((x) => ({
      Name: this.t.tr('role.' + x.Name),
      Id: x.Id,
    })).sort((a, b) => a.Name.localeCompare(b.Name));

    this.fm.init({
      context: 'user-list',
      storageKey: 'user-list',
      filters: {
        roleIds: {
          type: 'checkbox',
          label: this.t.tr('users.role'),
          name: 'roleIds',
          query: 'roleIds',
          originalData: roles,
          options: translatedRoles,
        },
      } satisfies Filters,
      defaultFilters: {
        roleIds: true,
      },
    });

    await this.getUsers();
  }

  @AsyncErrorHandler
  async getUsers() {
    const { data, headers } = await this.userService.getUsers(this.fm.queryFilter);
    const record = headers.get('x-total-count');
    this.fm.paginationTotalRecords = record ? +record : 0;
    this.users = data;
  }

  @AsyncErrorHandler
  async impersonateUser(id: string) {
    await this.accountService.impersonateUser(id);
    setTimeout(() => {
      this.router.navigate('/');
      window.location.reload();
    }, 500);
  }

  public translateRoles(roles: string): string {
    if (!roles) return '';
    return roles
      .split(',')
      .map((r) => this.t.tr(r.trim()))
      .sort((a, b) => a.localeCompare(b))
      .join(', ');
  }
}
